import { render } from "./CodeTextarea.vue?vue&type=template&id=3e335e5f&scoped=true"
import script from "./CodeTextarea.vue?vue&type=script&lang=js"
export * from "./CodeTextarea.vue?vue&type=script&lang=js"

import "./CodeTextarea.vue?vue&type=style&index=0&id=3e335e5f&lang=less&scoped=true"

import exportComponent from "/codebuild/output/src3271881597/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e335e5f"]])

export default __exports__